import React from "react";
import Frame133 from "../Frame133";
import "./Frame144.css";

function Frame144(props) {
  const { frame133Props } = props;

  return (
    <div className="frame-144">
      <Frame133 frame136Props={frame133Props.frame136Props} />
    </div>
  );
}

export default Frame144;
